module.exports = __webpack_public_path__ + "img/settingsBtnEN.7eb28437.png";